// 04-enforce.md 4.1 -- función pura extraída de OpDetailPanel.jsx. Dado el array de nodos del
// flow, el id de un nodo, el lado (`'in'`/`'out'`) y el índice de puerto, devuelve las
// coordenadas `{ x, y }` del puerto en el espacio del canvas. Las constantes por categoría de
// nodo (tamaños de avatar/círculo/rect + offsets) son las que ya estaban inline -- geometría
// del render, no lógica de negocio.

export function portCoord(flowNodes, nodeId, side, portIndex) {
  const n = (flowNodes || []).find(x => x.id === nodeId);
  if (!n) return { x: 0, y: 0 };
  const cat = n.category;

  // trigger: círculo de 50x50, puerto a top:50% = 25px
  if (cat === 'trigger') {
    if (n.sub === 'operacion-activa') {
      if (side === 'in') {
        if (portIndex === 1) return { x: n.x - 3, y: n.y + 18 };
        if (portIndex === 2) return { x: n.x - 3, y: n.y + 38 };
        return { x: n.x + 26, y: n.y };
      }
      const offsets = [20, 52, 84, 116];
      return { x: n.x + (offsets[portIndex] || 20), y: n.y + 56 };
    }
    const cy = n.y + 25;
    if (n.sub === 'ifelse' && side === 'out') return { x: n.x + 52, y: cy + (portIndex === 1 ? 10 : -10) };
    return side === 'out' ? { x: n.x + 52, y: cy } : { x: n.x - 3, y: cy };
  }
  // cliente: avatar 56px + label, puerto al centro vertical del avatar (~35px)
  if (cat === 'cliente') {
    return side === 'out'
      ? { x: n.x + 65, y: n.y + 35 }
      : { x: n.x - 3, y: n.y + 35 };
  }
  // oper: cuadrado 39x39 -- puertos arriba/abajo
  if (cat === 'oper') {
    return side === 'out'
      ? { x: n.x + 20, y: n.y + 39 + 7 }
      : { x: n.x + 20, y: n.y };
  }
  // documento: 56x49 -- puertos izquierda/derecha al centro vertical
  if (cat === 'documento') {
    const cy = n.y + 24;
    return side === 'out' ? { x: n.x + 57, y: cy } : { x: n.x - 3, y: cy };
  }
  // estructura: 140px de ancho -- array de puertos abajo, puerto `in` a la izquierda
  if (cat === 'estructura') {
    const bx = [n.x + 35, n.x + 70, n.x + 105];
    return side === 'out'
      ? { x: bx[portIndex || 0], y: n.y + 82 }
      : { x: n.x - 3, y: n.y + 32 };
  }
  return side === 'out' ? { x: n.x + 140, y: n.y + 24 } : { x: n.x - 3, y: n.y + 24 };
}
